module.exports = __webpack_public_path__ + "static/media/greenhouseStep3-1.7316dd34.jpg";